import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { gray } from 'styles/colors'
import { consultantAvailabilitySelector } from 'selectors'

const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
  color: ${gray};
`

const Calendar = styled.img`
  margin-right: 5px;
`

const Text = styled.div`
  text-align: left;
`

const Availability = ({ availability: { color, text, date }, className }) => (
  <Wrapper className={className}>
    <Calendar src={`/icons/calendar-${color}.svg`} alt="" />
    <div>
      <Text>{text}</Text>
      <Text>{date}</Text>
    </div>
  </Wrapper>
)

const mapStateToProps = (state, { consultantId }) => ({
  availability: consultantAvailabilitySelector(state, consultantId) || {},
})

export default connect(mapStateToProps)(Availability)



// WEBPACK FOOTER //
// ./src/components/Availability.js